module.exports = __webpack_public_path__ + "static/media/alien-mobile.1987ef20.png";